import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const deleteNotificationSetting = (notificationSettingId: number) =>
  createGenericDispatcher<number>({
    name: 'DELETE_NOTIFICATION_SETTINGS',
    loadFunction: () => Api.del(`/notification-settings/${notificationSettingId}`),
    args: { notificationSettingId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `delete-notification-setting-${notificationSettingId}`,
          message: 'Updated notification setting.',
        }),
      );
    },
  });
